<svg:svg
  [attr.width]="24 * 6"
  [attr.x]="dimensions.boundedWidth"
  [attr.y]="7 * this.dimensions.marginTop"
  >
  <svg:svg
    class="color-picker"
    [attr.width]="24 * 6"
    height="24"
    (click)="onClickOpen()"
    >
    @for (idx of numbers; track idx) {
      <svg:rect
        [style.fill]="brewer[selectedPalette][2 * idx]"
        width="24"
        height="24"
        [attr.x]="idx * 24"
        ></svg:rect>
      }
      <svg:svg height="24" width="24" [attr.x]="24 * 5" viewBox="0 0 24 24">
        @if (!open) {
          <svg:path d="m 13,6 -5,5 -5,-5 z" fill="#797979" />
        }
        @if (open) {
          <svg:path d="m 3,10 5,-5 5,5 z" fill="#797979" />
        }
        </svg:svg>
        </svg:svg>
        @if (open) {
          <svg:g class="color-chooser">
            @for (palette of palettes; track palette; let i = $index) {
              <svg:svg
                [attr.y]="(i + 1) * (24 + 2)"
                [attr.width]="24 * 6"
                [attr.height]="24 + 2"
                (click)="onSelectedPaletteChanged(palette)"
                >
                @for (idx of numbers; track idx) {
                  <svg:rect
                    [style.fill]="brewer[palette][2 * idx]"
                    width="24"
                    height="24"
                    [attr.x]="idx * 24"
                    ></svg:rect>
                  }
                  </svg:svg>
                }
                </svg:g>
              }
              </svg:svg>
